import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAppSelector } from "../redux/hooks";
import { MODULOS_POR_ROL } from "./MODULOS_POR_ROL";


export const ProtectedRoute:React.FC = () => {

    const { userData } = useAppSelector((state) => state.authReducer);
    const location = useLocation();

    const pathSegment = location.pathname.split("/")[1];

    const roles: string[] = [];

    if(userData.rolesInvestigacion!=null){
        if(userData.rolesInvestigacion.find(x=>x.idrol == 148))
            roles.push("esInvestigador");

        if(userData.rolesInvestigacion.find(x=>x.idrol == 142))
            roles.push("esAdministrador")

    }
        

    if(userData.unidadesDirectivo!=null){
        if(userData.unidadesDirectivo.tipoPersona=="S")
            roles.push("esDelegado")
    }
       

    if(userData.unidadesVicerrector!=null){
        if(userData.unidadesVicerrector.tipoPersona=="V"){
            roles.push("esVicerrector")
        }
    }
       

    const tieneAcceso = roles.some((rol: string) => {
        //console.log(rol)
        const modulos = MODULOS_POR_ROL[rol];
        //console.log(modulos);
        //console.log(pathSegment);
        return modulos?.includes(pathSegment);
    });
    
    if (!tieneAcceso) {
        return <Navigate to="/SinAcceso" replace />;
    }

    return <Outlet />;

}